import { createContext, useContext } from 'react';
import type { Lang } from '@onyx/shared';

const ru = {
  'tab.wallet': 'Главная',
  'tab.swap': 'Обмен',
  'tab.pay': 'Платежи',
  'tab.history': 'История',

  'home.deposit': 'Пополнить',
  'home.hello': 'Привет',
  'home.stories': 'Возможности кошелька',
  'home.topUp': 'Пополнить баланс',
  'home.sendFriend': 'Отправить другу',
  'home.sendFriendSub': 'Бесплатно по @username или чеком в чат',
  'home.withdrawSub': 'На внешний кошелёк или биржу',
  'home.send': 'Отправить',
  'home.swap': 'Обмен',
  'home.withdraw': 'Вывести',
  'home.cheques': 'Чеки',
  'home.invoices': 'Счета',
  'home.assets': 'Активы',
  'home.actions': 'Действия',
  'home.allAssets': 'Все активы',
  'home.hideZero': 'Скрыть пустые',
  'home.emptyTitle': 'Кошелёк пока пуст',
  'home.emptyBody': 'Пополните кошелёк USDT, TON, BTC или другой монетой — из любой сети.',
  'home.other': 'Другие',
  'home.selected': 'Нажмите ещё раз, чтобы открыть',
  'home.networks': (n: number) => `${n} ${plural(n, 'сеть', 'сети', 'сетей')}`,
  'home.pricesStale': 'Курсы временно не обновляются',

  'asset.available': 'Доступно',
  'asset.locked': 'В обработке',
  'asset.availableShort': 'доступно',
  'asset.price': 'Курс',
  'asset.networks': 'Сети',
  'asset.history': 'Операции',
  'asset.noHistory': 'По этому активу ещё не было операций.',

  'pick.asset': 'Выберите актив',
  'pick.network': 'Выберите сеть',
  'pick.search': 'Поиск',
  'pick.popular': 'Популярные',
  'pick.balance': 'На балансе',
  'pick.fee': 'Комиссия',
  'pick.min': 'Мин.',
  'settings.minWithdraw': 'Мин. вывод',
  'pick.minutes': (n: number) => `≈ ${n} мин`,

  'deposit.title': 'Пополнение',
  'deposit.address': 'Адрес',
  'deposit.memo': 'Комментарий (memo)',
  'deposit.memoWarn': 'Обязательно укажите комментарий при переводе. Без него зачисление не найдёт ваш кошелёк.',
  'deposit.onlyNetwork': (asset: string, net: string) => `Отправляйте только ${asset} в сети ${net}. Другие монеты и сети будут потеряны.`,
  'deposit.min': 'Минимум',
  'deposit.time': 'Зачисление',
  'deposit.confirmations': (n: number) => `${n} ${plural(n, 'подтверждение', 'подтверждения', 'подтверждений')}`,
  'deposit.copy': 'Скопировать',
  'deposit.copied': 'Скопировано',
  'deposit.share': 'Поделиться',
  'deposit.testnet': 'Тестовая сеть',
  'deposit.faucet': 'Тест-пополнение',
  'deposit.faucetDone': 'Тестовые монеты зачислены',
  'deposit.arrived': 'Зачислено',
  'deposit.waiting': (a: string) => `Слой ${a} вырастет, как только сеть подтвердит перевод.`,

  'withdraw.title': 'Вывод',
  'withdraw.address': 'Адрес получателя',
  'withdraw.addressPh': 'Вставьте или отсканируйте',
  'withdraw.memo': 'Комментарий (memo)',
  'withdraw.memoPh': 'Если биржа его требует',
  'withdraw.amount': 'Сумма',
  'withdraw.max': 'Макс',
  'withdraw.paste': 'Вставить',
  'withdraw.scan': 'Сканировать',
  'withdraw.invalidAddress': (net: string) => `Это не адрес сети ${net}`,
  'withdraw.internal': (name: string) => `Это кошелёк Onyx: ${name}. Перевод мгновенный и без комиссии.`,
  'withdraw.fee': 'Комиссия сети',
  'withdraw.receive': 'Получатель получит',
  'withdraw.total': 'Спишется с баланса',
  'withdraw.review': 'Проверить',
  'withdraw.confirmTitle': 'Проверьте вывод',
  'withdraw.network': 'Сеть',
  'withdraw.irreversible': 'Переводы в блокчейне необратимы. Убедитесь, что адрес и сеть верны.',
  'withdraw.hold': 'Удерживайте, чтобы отправить',
  'withdraw.sending': 'Отправляем…',
  'withdraw.doneTitle': 'Вывод создан',
  'withdraw.doneBody': 'Транзакция уйдёт в сеть в течение минуты. Статус — в истории.',
  'withdraw.reviewBody': 'Крупный вывод: оператор проверит его вручную, обычно до часа.',
  'withdraw.internalDone': 'Перевод доставлен мгновенно.',
  'withdraw.belowMin': (min: string) => `Минимум для вывода — ${min}`,
  'withdraw.notEnough': 'Недостаточно средств с учётом комиссии',

  'send.title': 'Отправить',
  'send.to': 'Кому',
  'send.toPh': 'username или Telegram ID',
  'send.recent': 'Недавние',
  'send.results': 'Пользователи Onyx',
  'send.change': 'Изменить',
  'send.comment': 'Комментарий',
  'send.commentPh': 'Необязательно',
  'send.found': 'Пользователь Onyx',
  'send.notFound': 'Такого пользователя в Onyx нет. Отправьте чеком — он сможет получить по ссылке.',
  'send.free': 'Бесплатно и мгновенно',
  'send.submit': 'Отправить',
  'send.asCheque': 'Отправить чеком в чат',
  'send.doneTitle': 'Отправлено',
  'send.chooseHow': 'Как отправить',
  'send.byUsername': 'Пользователю Onyx',
  'send.toAddress': 'На внешний адрес',
  'send.chequeHint': 'Создадим чек и откроем выбор чата',

  'swap.title': 'Обмен',
  'swap.give': 'Отдаёте',
  'swap.get': 'Получаете',
  'swap.rate': 'Курс',
  'swap.market': 'Рыночный курс',
  'swap.yourRate': 'Курс с комиссией',
  'swap.fee': 'Комиссия',
  'swap.value': 'В валюте',
  'swap.refresh': (s: number) => `Курс обновится через ${s} с`,
  'swap.submit': 'Обменять',
  'swap.flip': 'Поменять местами',
  'swap.after': 'Так будет после обмена',
  'swap.doneTitle': 'Обмен выполнен',
  'swap.expired': 'Курс устарел, запросили новый',

  'pay.title': 'Платежи',
  'pay.cheques': 'Чеки',
  'pay.invoices': 'Счета',
  'pay.newCheque': 'Создать чек',
  'pay.newInvoice': 'Выставить счёт',
  'pay.chequesEmpty': 'Чек — это ссылка с деньгами. Отправьте её в любой чат, и получатель заберёт сумму в один тап.',
  'pay.invoicesEmpty': 'Счёт — ссылка на оплату. Выставите его клиенту или другу и получите деньги прямо на баланс.',

  'cheque.title': 'Новый чек',
  'cheque.amount': 'Сумма одного чека',
  'cheque.activations': 'Активаций',
  'cheque.single': 'Одному',
  'cheque.multi': 'Мульти-чек',
  'cheque.multiShort': 'Мульти-чек',
  'cheque.password': 'Пароль',
  'cheque.passwordPh': 'Необязательно',
  'cheque.description': 'Подпись',
  'cheque.descriptionPh': 'Например, «С днём рождения»',
  'cheque.total': 'Будет списано',
  'cheque.create': 'Создать чек',
  'cheque.share': 'Отправить в чат',
  'cheque.copyLink': 'Скопировать ссылку',
  'cheque.cancel': 'Отменить и вернуть остаток',
  'cheque.activated': (a: number, b: number) => `Активирован ${a} из ${b}`,
  'cheque.status.active': 'Активен',
  'cheque.status.exhausted': 'Использован',
  'cheque.status.cancelled': 'Отменён',
  'cheque.from': 'Чек от',
  'cheque.claim': 'Получить',
  'cheque.claimed': 'Получено',
  'cheque.claimedBody': 'Деньги уже на вашем балансе.',
  'cheque.alreadyClaimed': 'Вы уже получили этот чек.',
  'cheque.own': 'Это ваш чек. Отправьте ссылку получателю.',
  'cheque.gone': 'Чек уже использован или отменён.',
  'cheque.enterPassword': 'Чек защищён паролем',
  'cheque.withPassword': 'С паролем',

  'invoice.title': 'Новый счёт',
  'invoice.amount': 'Сумма',
  'invoice.description': 'За что',
  'invoice.descriptionPh': 'Например, «Дизайн логотипа»',
  'invoice.expires': 'Срок оплаты',
  'invoice.never': 'Бессрочно',
  'invoice.hours': (h: number) => (h < 24 ? `${h} ч` : `${h / 24} ${plural(h / 24, 'день', 'дня', 'дней')}`),
  'invoice.create': 'Выставить счёт',
  'invoice.pay': 'Оплатить',
  'invoice.payTitle': 'Счёт на оплату',
  'invoice.from': 'Получатель',
  'invoice.paidTitle': 'Оплачено',
  'invoice.status.active': 'Ждёт оплаты',
  'invoice.status.paid': 'Оплачен',
  'invoice.status.expired': 'Истёк',
  'invoice.status.cancelled': 'Отменён',
  'invoice.cancel': 'Отменить счёт',
  'invoice.paidBy': 'Оплатил',
  'invoice.own': 'Это ваш счёт. Отправьте ссылку плательщику.',
  'invoice.gone': 'Этот счёт уже оплачен или больше не действует.',
  'invoice.youHave': 'На балансе',

  'history.title': 'История',
  'history.all': 'Все',
  'history.in': 'Пополнения',
  'history.out': 'Выводы',
  'history.transfers': 'Переводы',
  'history.swaps': 'Обмены',
  'history.cheques': 'Чеки и счета',
  'history.empty': 'Операций пока нет. Первое пополнение появится здесь сразу, как только сеть его увидит.',
  'history.more': 'Показать ещё',
  'history.today': 'Сегодня',
  'history.yesterday': 'Вчера',

  'type.deposit': 'Пополнение',
  'type.withdraw': 'Вывод',
  'type.transfer_in': 'Перевод от',
  'type.transfer_out': 'Перевод для',
  'type.swap': 'Обмен',
  'type.cheque_create': 'Чек создан',
  'type.cheque_claim': 'Чек от',
  'type.cheque_refund': 'Возврат по чеку',
  'type.invoice_pay': 'Оплата счёта',
  'type.invoice_receive': 'Оплата от',
  'type.adjustment': 'Корректировка от поддержки',

  'status.pending': 'Ожидает подтверждений',
  'status.review': 'На проверке',
  'status.processing': 'Отправляется',
  'status.completed': 'Выполнено',
  'status.failed': 'Не прошло',
  'status.cancelled': 'Отменено',

  'detail.code': 'Код операции',
  'detail.date': 'Дата',
  'detail.network': 'Сеть',
  'detail.address': 'Адрес',
  'detail.tx': 'Транзакция',
  'detail.explorer': 'Открыть в обозревателе',
  'detail.fee': 'Комиссия',
  'detail.comment': 'Комментарий',
  'detail.confirmations': 'Подтверждения',
  'detail.cancel': 'Отменить вывод',

  'settings.title': 'Настройки',
  'settings.currency': 'Валюта отображения',
  'settings.language': 'Язык',
  'settings.theme': 'Оформление',
  'settings.theme.auto': 'Как в Telegram',
  'settings.theme.dark': 'Тёмная',
  'settings.theme.light': 'Светлая',
  'settings.fees': 'Комиссии и лимиты',
  'settings.feesNote': 'Переводы внутри Onyx, чеки и счета — бесплатно. При выводе берётся только сетевая комиссия ниже.',
  'settings.swapFee': (p: string) => `Комиссия обмена — ${p}%`,
  'settings.id': 'Ваш ID',
  'settings.admin': 'Админ-панель',
  'settings.adminSub': 'Выводы, сбор депозитов, резервы, пользователи',
  'settings.support': 'Поддержка',

  'common.continue': 'Продолжить',
  'common.done': 'Готово',
  'common.cancel': 'Отмена',
  'common.retry': 'Повторить',
  'common.close': 'Закрыть',
  'common.confirmAgain': 'Нажмите ещё раз',
  'common.back': 'Назад',
  'common.all': 'Все',
  'common.balance': 'Баланс',
  'common.free': 'Бесплатно',
  'common.loading': 'Загрузка',
  'common.error': 'Не получилось загрузить. Проверьте соединение и попробуйте ещё раз.',
  'common.offline': 'Нет соединения с сервером',
  'common.signIn': 'Войти через Telegram',
  'common.signInBody': 'Onyx работает внутри Telegram. Откройте бота или войдите через Telegram в браузере.',

  'err.insufficient_funds': 'Недостаточно средств',
  'err.invalid_amount': 'Введите сумму',
  'err.invalid_address': 'Адрес не подходит для выбранной сети',
  'err.below_minimum': 'Сумма меньше минимальной',
  'err.recipient_not_found': 'Пользователь не найден',
  'err.self_transfer': 'Нельзя отправить самому себе',
  'err.quote_expired': 'Курс устарел, обновите',
  'err.wrong_password': 'Неверный пароль',
  'err.already_claimed': 'Вы уже получили этот чек',
  'err.cheque_inactive': 'Чек уже использован',
  'err.own_cheque': 'Это ваш собственный чек',
  'err.invoice_inactive': 'Счёт больше не действует',
  'err.own_invoice': 'Нельзя оплатить свой счёт',
  'err.not_cancellable': 'Уже нельзя отменить',
  'err.amount_too_small': 'Слишком маленькая сумма',
  'err.unauthorized': 'Сессия истекла, откройте кошелёк заново',
  'err.account_frozen': 'Аккаунт заморожен. Напишите в поддержку.',
  'err.forbidden': 'Нет доступа',
  'err.network': 'Нет соединения. Попробуйте ещё раз.',
  'err.unknown': 'Что-то пошло не так. Попробуйте ещё раз.',
};

type Dict = typeof ru;

const en: Dict = {
  ...ru,
  'tab.wallet': 'Home',
  'tab.swap': 'Swap',
  'tab.pay': 'Payments',
  'tab.history': 'History',
  'home.deposit': 'Deposit',
  'home.hello': 'Hi',
  'home.stories': 'Wallet features',
  'home.topUp': 'Top up balance',
  'home.sendFriend': 'Send to a friend',
  'home.sendFriendSub': 'Free by @username or as a cheque in a chat',
  'home.withdrawSub': 'To an external wallet or exchange',
  'home.send': 'Send',
  'home.swap': 'Swap',
  'home.withdraw': 'Withdraw',
  'home.cheques': 'Cheques',
  'home.invoices': 'Invoices',
  'home.assets': 'Assets',
  'home.actions': 'Actions',
  'home.allAssets': 'All assets',
  'home.hideZero': 'Hide empty',
  'home.emptyTitle': 'Your wallet is empty',
  'home.emptyBody': 'Deposit USDT, TON, BTC or another coin from any network.',
  'home.other': 'Other',
  'home.selected': 'Tap again to open',
  'home.networks': (n: number) => `${n} network${n === 1 ? '' : 's'}`,
  'home.pricesStale': 'Rates are temporarily not updating',
  'asset.available': 'Available',
  'asset.locked': 'Processing',
  'asset.availableShort': 'available',
  'asset.price': 'Price',
  'asset.networks': 'Networks',
  'asset.history': 'Activity',
  'asset.noHistory': 'No activity for this asset yet.',
  'pick.asset': 'Choose asset',
  'pick.network': 'Choose network',
  'pick.search': 'Search',
  'pick.popular': 'Popular',
  'pick.balance': 'In wallet',
  'pick.fee': 'Fee',
  'pick.min': 'Min.',
  'settings.minWithdraw': 'Min. withdrawal',
  'pick.minutes': (n: number) => `≈ ${n} min`,
  'deposit.title': 'Deposit',
  'deposit.address': 'Address',
  'deposit.memo': 'Comment (memo)',
  'deposit.memoWarn': 'Always include the comment. Without it the deposit cannot find your wallet.',
  'deposit.onlyNetwork': (asset: string, net: string) => `Send only ${asset} on ${net}. Other coins or networks will be lost.`,
  'deposit.min': 'Minimum',
  'deposit.time': 'Credited after',
  'deposit.confirmations': (n: number) => `${n} confirmation${n === 1 ? '' : 's'}`,
  'deposit.copy': 'Copy',
  'deposit.copied': 'Copied',
  'deposit.share': 'Share',
  'deposit.testnet': 'Testnet',
  'deposit.faucet': 'Test deposit',
  'deposit.faucetDone': 'Test coins credited',
  'deposit.arrived': 'Credited',
  'deposit.waiting': (a: string) => `The ${a} layer grows as soon as the network confirms the transfer.`,
  'withdraw.title': 'Withdraw',
  'withdraw.address': 'Recipient address',
  'withdraw.addressPh': 'Paste or scan',
  'withdraw.memo': 'Comment (memo)',
  'withdraw.memoPh': 'If the exchange requires it',
  'withdraw.amount': 'Amount',
  'withdraw.max': 'Max',
  'withdraw.paste': 'Paste',
  'withdraw.scan': 'Scan',
  'withdraw.invalidAddress': (net: string) => `Not a ${net} address`,
  'withdraw.internal': (name: string) => `This is an Onyx wallet: ${name}. Instant and free.`,
  'withdraw.fee': 'Network fee',
  'withdraw.receive': 'Recipient gets',
  'withdraw.total': 'Total debit',
  'withdraw.review': 'Review',
  'withdraw.confirmTitle': 'Review withdrawal',
  'withdraw.network': 'Network',
  'withdraw.irreversible': 'Blockchain transfers cannot be reversed. Check the address and network.',
  'withdraw.hold': 'Hold to send',
  'withdraw.sending': 'Sending…',
  'withdraw.doneTitle': 'Withdrawal created',
  'withdraw.doneBody': 'It goes on chain within a minute. Track it in History.',
  'withdraw.reviewBody': 'Large withdrawal: an operator reviews it, usually within an hour.',
  'withdraw.internalDone': 'Delivered instantly.',
  'withdraw.belowMin': (min: string) => `Minimum withdrawal is ${min}`,
  'withdraw.notEnough': 'Not enough balance including the fee',
  'send.title': 'Send',
  'send.to': 'To',
  'send.toPh': 'username or Telegram ID',
  'send.recent': 'Recent',
  'send.results': 'Onyx users',
  'send.change': 'Change',
  'send.comment': 'Comment',
  'send.commentPh': 'Optional',
  'send.found': 'Onyx user',
  'send.notFound': 'No such Onyx user. Send a cheque instead — they can claim it from a link.',
  'send.free': 'Free and instant',
  'send.submit': 'Send',
  'send.asCheque': 'Send as a cheque to a chat',
  'send.doneTitle': 'Sent',
  'send.chooseHow': 'How to send',
  'send.byUsername': 'To an Onyx user',
  'send.toAddress': 'To an external address',
  'send.chequeHint': 'Creates a cheque and opens the chat picker',
  'swap.title': 'Swap',
  'swap.give': 'You give',
  'swap.get': 'You get',
  'swap.rate': 'Rate',
  'swap.market': 'Market rate',
  'swap.yourRate': 'Rate after fee',
  'swap.fee': 'Fee',
  'swap.value': 'Value',
  'swap.refresh': (s: number) => `Rate refreshes in ${s}s`,
  'swap.submit': 'Swap',
  'swap.flip': 'Flip',
  'swap.after': 'Your wallet after the swap',
  'swap.doneTitle': 'Swapped',
  'swap.expired': 'Rate expired, fetched a new one',
  'pay.title': 'Payments',
  'pay.cheques': 'Cheques',
  'pay.invoices': 'Invoices',
  'pay.newCheque': 'New cheque',
  'pay.newInvoice': 'New invoice',
  'pay.chequesEmpty': 'A cheque is a link with money in it. Drop it in any chat and the recipient claims it in one tap.',
  'pay.invoicesEmpty': 'An invoice is a payment link. Send it to a client or friend and get paid straight to your balance.',
  'cheque.title': 'New cheque',
  'cheque.amount': 'Amount per cheque',
  'cheque.activations': 'Activations',
  'cheque.single': 'One person',
  'cheque.multi': 'Multi-cheque',
  'cheque.multiShort': 'Multi-cheque',
  'cheque.password': 'Password',
  'cheque.passwordPh': 'Optional',
  'cheque.description': 'Caption',
  'cheque.descriptionPh': 'e.g. “Happy birthday”',
  'cheque.total': 'Will be debited',
  'cheque.create': 'Create cheque',
  'cheque.share': 'Send to a chat',
  'cheque.copyLink': 'Copy link',
  'cheque.cancel': 'Cancel and refund the rest',
  'cheque.activated': (a: number, b: number) => `${a} of ${b} claimed`,
  'cheque.status.active': 'Active',
  'cheque.status.exhausted': 'Used',
  'cheque.status.cancelled': 'Cancelled',
  'cheque.from': 'Cheque from',
  'cheque.claim': 'Claim',
  'cheque.claimed': 'Claimed',
  'cheque.claimedBody': 'The money is on your balance.',
  'cheque.alreadyClaimed': 'You already claimed this cheque.',
  'cheque.own': 'This is your cheque. Send the link to the recipient.',
  'cheque.gone': 'This cheque is used up or cancelled.',
  'cheque.enterPassword': 'This cheque is password-protected',
  'cheque.withPassword': 'Password',
  'invoice.title': 'New invoice',
  'invoice.amount': 'Amount',
  'invoice.description': 'For',
  'invoice.descriptionPh': 'e.g. “Logo design”',
  'invoice.expires': 'Pay within',
  'invoice.never': 'No limit',
  'invoice.hours': (h: number) => (h < 24 ? `${h} h` : `${h / 24} d`),
  'invoice.create': 'Create invoice',
  'invoice.pay': 'Pay',
  'invoice.payTitle': 'Invoice',
  'invoice.from': 'Payee',
  'invoice.paidTitle': 'Paid',
  'invoice.status.active': 'Awaiting payment',
  'invoice.status.paid': 'Paid',
  'invoice.status.expired': 'Expired',
  'invoice.status.cancelled': 'Cancelled',
  'invoice.cancel': 'Cancel invoice',
  'invoice.paidBy': 'Paid by',
  'invoice.own': 'This is your invoice. Send the link to the payer.',
  'invoice.gone': 'This invoice is paid or no longer valid.',
  'invoice.youHave': 'In wallet',
  'history.title': 'History',
  'history.all': 'All',
  'history.in': 'Deposits',
  'history.out': 'Withdrawals',
  'history.transfers': 'Transfers',
  'history.swaps': 'Swaps',
  'history.cheques': 'Cheques & invoices',
  'history.empty': 'No activity yet. Your first deposit shows up here as soon as the network sees it.',
  'history.more': 'Show more',
  'history.today': 'Today',
  'history.yesterday': 'Yesterday',
  'type.deposit': 'Deposit',
  'type.withdraw': 'Withdrawal',
  'type.transfer_in': 'From',
  'type.transfer_out': 'To',
  'type.swap': 'Swap',
  'type.cheque_create': 'Cheque created',
  'type.cheque_claim': 'Cheque from',
  'type.cheque_refund': 'Cheque refund',
  'type.invoice_pay': 'Invoice paid',
  'type.invoice_receive': 'Payment from',
  'type.adjustment': 'Support adjustment',
  'status.pending': 'Awaiting confirmations',
  'status.review': 'Under review',
  'status.processing': 'Sending',
  'status.completed': 'Completed',
  'status.failed': 'Failed',
  'status.cancelled': 'Cancelled',
  'detail.code': 'Reference',
  'detail.date': 'Date',
  'detail.network': 'Network',
  'detail.address': 'Address',
  'detail.tx': 'Transaction',
  'detail.explorer': 'Open in explorer',
  'detail.fee': 'Fee',
  'detail.comment': 'Comment',
  'detail.confirmations': 'Confirmations',
  'detail.cancel': 'Cancel withdrawal',
  'settings.title': 'Settings',
  'settings.currency': 'Display currency',
  'settings.language': 'Language',
  'settings.theme': 'Appearance',
  'settings.theme.auto': 'Match Telegram',
  'settings.theme.dark': 'Dark',
  'settings.theme.light': 'Light',
  'settings.fees': 'Fees and limits',
  'settings.feesNote': 'Transfers inside Onyx, cheques and invoices are free. Withdrawals pay only the network fee below.',
  'settings.swapFee': (p: string) => `Swap fee — ${p}%`,
  'settings.id': 'Your ID',
  'settings.admin': 'Admin panel',
  'settings.adminSub': 'Withdrawals, sweeps, reserves, users',
  'settings.support': 'Support',
  'common.continue': 'Continue',
  'common.done': 'Done',
  'common.cancel': 'Cancel',
  'common.retry': 'Retry',
  'common.close': 'Close',
  'common.confirmAgain': 'Tap again to confirm',
  'common.back': 'Back',
  'common.all': 'All',
  'common.balance': 'Balance',
  'common.free': 'Free',
  'common.loading': 'Loading',
  'common.error': 'Could not load. Check your connection and try again.',
  'common.offline': 'No connection to the server',
  'common.signIn': 'Sign in with Telegram',
  'common.signInBody': 'Onyx lives inside Telegram. Open the bot, or sign in with Telegram in the browser.',
  'err.insufficient_funds': 'Not enough balance',
  'err.invalid_amount': 'Enter an amount',
  'err.invalid_address': 'Address does not match the network',
  'err.below_minimum': 'Below the minimum',
  'err.recipient_not_found': 'User not found',
  'err.self_transfer': 'You cannot send to yourself',
  'err.quote_expired': 'Rate expired, refresh',
  'err.wrong_password': 'Wrong password',
  'err.already_claimed': 'You already claimed this cheque',
  'err.cheque_inactive': 'This cheque is used up',
  'err.own_cheque': 'This is your own cheque',
  'err.invoice_inactive': 'This invoice is no longer valid',
  'err.own_invoice': 'You cannot pay your own invoice',
  'err.not_cancellable': 'Can no longer be cancelled',
  'err.amount_too_small': 'Amount is too small',
  'err.unauthorized': 'Session expired, reopen the wallet',
  'err.account_frozen': 'This account is frozen. Contact support.',
  'err.forbidden': 'Access denied',
  'err.network': 'No connection. Try again.',
  'err.unknown': 'Something went wrong. Try again.',
};

function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

export const dictionaries: Record<Lang, Dict> = { ru, en };
export type { Dict };

export const LangContext = createContext<Lang>('ru');
export const useLang = () => useContext(LangContext);
export const useT = () => dictionaries[useLang()];

export function errorText(t: Dict, code: string | undefined): string {
  const key = `err.${code}` as keyof Dict;
  const value = t[key];
  return typeof value === 'string' ? value : t['err.unknown'];
}
